<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :disabled="readonly"
    max-width="290px"
    min-width="290px"
    class="dialog-date-picker"
  >
    <template v-slot:activator="{ on, attrs }">
      <p class="dialog-date-picker-label my-0">{{ label }}</p>
      <v-text-field
        class="dialog-date-picker-input"
        :class="readonly ? 'readonly' : ''"
        v-model="dateFormatted"
        label="Date"
        height="48"
        v-bind="attrs"
        append-icon="mdi-calendar-blank"
        solo
        flat
        :readonly="readonly"
        dense
        hide-details
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="date"
      no-title
      :readonly="readonly"
      :min="minDate"
      @input="datePicked"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DialogDatePicker',
  props: {
    name: {
      type: String,
      default: 'date',
    },
    label: {
      type: String,
      default: 'date',
    },
    initialDate: {
      type: String,
      default: new Date().toISOString().substr(0, 10),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      date: '',
      dateFormatted: '',
      menu: false,
    }
  },

  mounted() {
    this.date = this.initialDate
    this.dateFormatted = this.formatDate(this.initialDate)
  },
  watch: {
    initialDate(val) {
      this.date = val
      this.dateFormatted = this.formatDate(val)
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    datePicked(date) {
      this.menu = false
      this.dateFormatted = this.formatDate(date)
      this.$emit('input', { name: this.name, value: this.date })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.dialog-date-picker {
  &-label {
    color: $bh-gray--2;
  }
  &-input {
    ::v-deep .v-icon.mdi.mdi-calendar-blank {
      background-color: $bh-blue--4;
      color: $bh-blue;
      padding: 0.25 * $gutter;
    }
    &.readonly {
      &.v-input--is-readonly {
        .v-input__control {
          .v-input__slot {
            background-color: transparent !important;
          }
        }
      }
      ::v-deep .v-icon.mdi.mdi-calendar-blank {
        color: $bh-gray--2 !important;
      }
    }
  }
}
</style>
